export type Config = {
  tehtavaSeriesId: string
  tehtavaApiUrl: string
  vuorovaikutusApiUrl: string
  imagesApiAppId: string
  imagesApiAppKey: string
  imagesApiUrl: string
  jsonStorageApiUrl: string
  imsUrl: string
  showDevTools: boolean
  feedbackLink: string
  useWebviewGuard: boolean
  revealLeaderboardButtonAfterUTC: string
  useVuorovaikutusApi: boolean
}

export type Env = 'prod' | 'test' | 'dev'

declare global {
  interface Window {
    getEnv: () => Env
  }
}

const config: Record<Env, Config> = {
  prod: {
    tehtavaSeriesId: '8c5247d8-5418-4606-bd92-5767721f0341',
    tehtavaApiUrl: 'https://tehtava.api.yle.fi/v1',
    vuorovaikutusApiUrl: 'https://vuorovaikutus.api.yle.fi',
    jsonStorageApiUrl: 'https://json-storage.api.yle.fi/v1',
    imagesApiAppId: 'tehtava-ui',
    imagesApiAppKey: 'ZkGFQxaoHstVGX2A4yR334QpI8fIwvCV',
    imagesApiUrl: 'https://images.api.yle.fi/v1',
    imsUrl: 'https://images.cdn.yle.fi/image/upload/fl_keep_iptc,f_auto,fl_progressive/q_80',
    showDevTools: false,
    feedbackLink: 'https://forms.gle/AN3kz8iA2BFuSSev7',
    useWebviewGuard: true,
    revealLeaderboardButtonAfterUTC: '2023-02-05',
    useVuorovaikutusApi: false
  },
  test: {
    tehtavaSeriesId: 'eb50edca-1329-41ea-9b6a-8c23b37e0879',
    tehtavaApiUrl: 'https://tehtava.api-test.yle.fi/v1',
    vuorovaikutusApiUrl: 'https://vuorovaikutus.api-test.yle.fi',
    imagesApiAppId: 'tehtava-ui',
    imagesApiAppKey: 'ZkGFQxaoHstVGX2A4yR334QpI8fIwvCV',
    imagesApiUrl: 'https://images.api.yle.fi/v1',
    jsonStorageApiUrl: 'https://json-storage.api.yle.fi/v1',
    imsUrl: 'https://images.cdn.yle.fi/image/upload/fl_keep_iptc,f_auto,fl_progressive/q_80',
    showDevTools: true,
    feedbackLink: 'https://forms.gle/AN3kz8iA2BFuSSev7',
    useWebviewGuard: false,
    revealLeaderboardButtonAfterUTC: '2023-02-05',
    useVuorovaikutusApi: false
  },
  dev: {
    tehtavaSeriesId: 'eb50edca-1329-41ea-9b6a-8c23b37e0879',
    tehtavaApiUrl: 'https://tehtava.api-test.yle.fi/v1',
    vuorovaikutusApiUrl: 'https://interaction.test.yle.fi',
    imagesApiAppId: 'tehtava-ui',
    imagesApiAppKey: 'ZkGFQxaoHstVGX2A4yR334QpI8fIwvCV',
    imagesApiUrl: 'https://images.api.yle.fi/v1',
    jsonStorageApiUrl: 'https://json-storage.api.yle.fi/v1',
    imsUrl: 'https://images.cdn.yle.fi/image/upload/fl_keep_iptc,f_auto,fl_progressive/q_80',
    showDevTools: true,
    feedbackLink: 'https://forms.gle/AN3kz8iA2BFuSSev7',
    useWebviewGuard: false,
    revealLeaderboardButtonAfterUTC: '2023-02-05',
    useVuorovaikutusApi: false
  }
}

export default config[window.getEnv()]
